<template>
    <div class="detail-info">
        <div class="campaign-name">
            {{campaign.name}}
        </div>
        <div class="detail-info-1">
            <div class="detail-rate">
                <div class="star-rate">
                    <img src="../../../../assets/new/icon/ic-star-100.png"/>
                    <img src="../../../../assets/new/icon/ic-star-100.png"/>
                    <img src="../../../../assets/new/icon/ic-star-100.png"/>
                    <img src="../../../../assets/new/icon/ic-star-100.png"/>
                    <img src="../../../../assets/new/icon/ic-star-100.png"/>
                    <!-- <img src="../../../../assets/new/icon/ic-star-50.png"/> -->
                    <!-- <img src="../../../../assets/new/icon/ic-star-0.png"/> -->
                    <!-- <img src="../../../../assets/new/icon/ic-star-0.png"/> -->
                </div>
                <div class="score-rate">
                    5
                </div>
            </div>
            <div class="detail-icon">
                <div @click="setFavorite(isFavorite)">
                    <img v-if="isFavorite" src="../../../../assets/new/icon/ic-favorite.png"/>
                    <img v-else src="../../../../assets/new/icon/ic-favorite-un.png"/>
                </div>
                <img @click="clickShare()" src="../../../../assets/new/icon/ic-share.png"/>
            </div>
        </div>
        <div v-if="isFlashSale">
            <FlashSaleBar
                :campaign="campaign"
            ></FlashSaleBar>
        </div>
        <div class="detail-price">
            <div class="price-unit">{{getUnit()}}</div>
            <div class="original-price" v-if="blobConfig.app_redeem_type != 'point'">{{getOriginalPrice()}}</div>
            <div class="unit">/ชิ้น</div>
            <div class="discount" v-if="campaign.discount > 0">
                <div class="text">ส่วนลด {{ getDiscount() }}%</div>
            </div>
        </div>
        <modal-master :controller="modalController"></modal-master>
    </div>
</template>
<script>
// mixin
import ModalMixin from '@/mixin/ModalMixin';
import AccountMixin from '@/mixin/AccountMixin';
import Moment from 'moment';
//helper
import Account from "@/helper/AccountHelper.js";
import Util from '@/helper/Utility.js';
import FlashSaleBar from './FlashSaleBar.vue';
//service
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign';
export default {
    name: 'DetailInfo',
    mixins:[ModalMixin,AccountMixin],
    components: {
        FlashSaleBar
    },
    props: {
        lbl: Object,
        campaign: Object,
    },
    data: function() {
        return {
            isFlashSale: false,
            isFavorite: this.campaign.isFavourite,
            shareModal: null,
        }
    },
    created: function () {
        this.blobConfig = Account.getCacheBlob("BlobConfig")
        if (this.$route.name == 'campaignflashsale') {
            this.isFlashSale = true
        }
    },
    methods: {
        getPointTxt: function () {
            var pointTypeTxt = this.campaign.pointType && this.campaign.pointType != 'use'
                            ? this.lbl.detail.get_point
                            : this.lbl.detail.use_point;

            var pointUnit = this.localeCode === 1033 && this.campaign.pointPerUnit > 1
                        ? this.lbl.detail.point_unit + 's'
                        : this.lbl.detail.point_unit;

            return `${pointTypeTxt}${this.campaign.pointPerUnit} ${pointUnit}`;
        },
        getExpireDate: function () {
            var expireDate = this.campaign.expireDate;
            var message = this.lbl.detail.expire_date;

            var result = Moment.unix(expireDate);
            var year = Moment.unix(expireDate).format('YYYY');
            if (this.localeCode === 1054)
                year = result.get('year') + 543;

            year = year.toString().substring(2, 4);
            var month = this.lbl.date.month_full[result.format('M') - 1];
            var day = result.format('DD');
            var date = `${day} ${month} ${year}`;

            return Util.stringFormat(message, date);
        },
        getUnit: function() {
            if (this.blobConfig.app_redeem_type == "point") {
                return Util.stringFormat(this.lbl.B2B.campaign.point,Util.formatNum(Number(this.campaign.pointPerUnit)));
            } else {
                return Util.stringFormat(this.lbl.B2B.campaign.price,Util.formatNum(Number(this.campaign.pricePerUnit)));
            }
        },
        getOriginalPrice: function () {
            return Util.stringFormat(this.lbl.B2B.campaign.price,Util.formatNum(Number(this.campaign.originalPrice)));
        },
        setFavorite: async function(fav) {
            if (this.isLogin) {
                if(fav) {
                    this.removeFavorite()
                }else{
                    this.addFavorite()
                }
            } else {
                this.goLogin();
            }
        },
        addFavorite: async function() {
            var strBzbsToken = Account.getToken();
            BzbsCampaign.apiAddFavourite(strBzbsToken, this.$route.params.campaignId).subscribe((data) => {
                this.isFavorite = data.Favourite === 0
            }, (err) => {
                console.log(err);
            });
        },
        removeFavorite: async function() {
            var strBzbsToken = Account.getToken();
            BzbsCampaign.apiRemoveFavourite(strBzbsToken, this.$route.params.campaignId).subscribe((data) => {
                this.isFavorite = data.Favourite === 0
            }, (err) => {
                console.log(err);
            });
        },
        clickShare: function () {
            this.shareModal
                .clearModal()
                .setTitle(this.lbl.detail.share)
                .setMsg(this.lbl.detail.page_link)
                .setUrl(window.location.href)
                .setBtnCancel('Close')
                .setBtnOk('Submit')
                .show()
            // this.shareModal.onClickOk(() => {
            //     var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            //     cacheHelper.removeCache('BzbsUser');
            //     this.$nextTick(() => {
            //         this.$router.push({ path: '/login', query: { app_id: this.appId } })
            //     })
            // })
        },
        getDiscount: function() {
            return Util.formatNum(this.campaign.discount)
        },
        goLogin: function() {
            this.confirmModal
                .clearModal()
                .setTitle(this.lbl.alert_popup.login.title)
                .setMsg(this.lbl.alert_popup.login.msg)
                .setBtnOk(this.lbl.alert_popup.login.btnOk)
                .setBtnCancel(this.lbl.alert_popup.login.btnCancel)
                .show();
            this.confirmModal.onClickOk(() => {
                this.$router.push('/login')
            })
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/base/baseText.scss";

.detail-info {
    .campaign-name {
        font-size: $px16;
        color: $a-black-333333;
    }
}
.detail-info-1 {
    display: flex;
    justify-content: space-between;
    padding: 20px 0 15px;
    .detail-rate {
        display: flex;
        margin: auto 0;
        gap: 16px;
        .star-rate {
            display: flex;
            margin: auto 0;
            img {
                width: 20px;
                height: 20px;
            }
        }
        .score-rate {
            font-size: $px16;
            color: $a-black-333333;
            padding-top: 6px;
        }
    }

    .detail-icon {
        display: flex;
        gap: 15px;
        img {
            height: 45px;
            width: auto;
            cursor: pointer;
        }
    }
}
.detail-price {
    display: flex;
    gap: 8px;
    padding: 15px 0 0;
    .price-unit {
        font-family: $ff-semi-bold;
        font-size: $px24;
        font-weight: 500;
        color: $a-red-ff0000;
    }
    .original-price{
        font-size: $px14;
        color: $a-gray-999999;
        text-decoration-line: line-through;
        padding-top: 10px;
    }
    .unit {
        font-size: $px14;
        color: $a-gray-999999;
        padding-top: 10px;
    }

    .discount {
        display: flex;
        margin: auto 0;
        background-color: $a-red-ff0000;
        color: white;
        padding: 0 8px;
        border-radius: 4px;
        font-size: $px14;
    }
}
</style>
